<template>
  <GlobalSearch v-bind="$attrs" />
</template>

<script>
// @ is an alias to /src
import GlobalSearch from "@/components/GlobalSearch.vue";

export default {
  name: "Global",
  components: {
    GlobalSearch
  },
  metaInfo: {
    title: "Search"
  }
};
</script>
